/**
 * Extract initials from user name data
 * Follows immutable pattern by creating new strings without mutations
 */
export const getInitials = (
  firstName?: string,
  lastName?: string,
  fallback: string = 'U'
): string => {
  // Trim whitespace to treat whitespace-only strings as missing
  const trimmedFirst = firstName?.trim();
  const trimmedLast = lastName?.trim();

  if (trimmedFirst && trimmedLast) {
    return trimmedFirst.charAt(0).toUpperCase() + trimmedLast.charAt(0).toUpperCase();
  }

  if (trimmedFirst) {
    return trimmedFirst.charAt(0).toUpperCase();
  }

  if (trimmedLast) {
    return trimmedLast.charAt(0).toUpperCase();
  }

  return fallback;
};
